var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSharedDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ver_detalle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_222",
    "data-name": "Rect\\xE1ngulo 222",
    width: 30,
    height: 30,
    transform: "translate(754 700)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22",
    "data-name": "Rect\\xE1ngulo 22",
    width: 14.937,
    height: 14.94,
    fill: "#e0e0e0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_33",
    "data-name": "Enmascarar grupo 33",
    transform: "translate(-754 -700)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16",
    transform: "translate(763.063 708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M6.322,46.372h-4.2A2.015,2.015,0,0,1,0,44.257q0-4.21,0-8.42a2.011,2.011,0,0,1,2.1-2.1q2.935,0,5.87,0a.578.578,0,0,1,.624.495.571.571,0,0,1-.537.652c-.06,0-.12,0-.179,0H2.129a.875.875,0,0,0-.98.97q0,4.2,0,8.4a.875.875,0,0,0,.963.97H10.53a.871.871,0,0,0,.959-.956q0-3.2,0-6.392a1.128,1.128,0,0,1,.016-.25.573.573,0,0,1,1.131.108c0,.024,0,.048,0,.072q0,3.268,0,6.535a1.988,1.988,0,0,1-1.546,1.971,2.416,2.416,0,0,1-.55.058c-1.406,0-2.812,0-4.218,0",
    transform: "translate(0 -31.433)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M92.391,1.972c-.074.069-.122.111-.166.156Q88.809,5.542,85.4,8.959a.6.6,0,0,1-.643.206.57.57,0,0,1-.266-.916c.042-.05.091-.1.137-.142L91.4,1.327c.046-.046.1-.084.152-.126l-.017-.052h-.18c-.8,0-1.6,0-2.405,0a.578.578,0,0,1-.58-.507A.578.578,0,0,1,88.806.02.876.876,0,0,1,89.019,0H92.9a.584.584,0,0,1,.643.646q0,1.939,0,3.878a.578.578,0,1,1-1.148.006q0-1.176,0-2.352Z",
    transform: "translate(-78.603 0)",
    fill: "#e0e0e0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSharedDisabled);
export default __webpack_public_path__ + "static/media/icon_shared_disabled.c2c6f4903a41d79aacd215f2f9bf9628.svg";
export { ForwardRef as ReactComponent };